import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import './cookieBanner.css';
import Button from '../Button/Button';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const cookieConsent = Cookies.get('cookieConsent');
        if (!cookieConsent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        Cookies.set('cookieConsent', 'accepted', { expires: 365 });
        setIsVisible(false);
    };

    const handleDecline = () => {
        Cookies.set('cookieConsent', 'declined', { expires: 365 });
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-banner">
            <p className="body-l cookie">
                We gebruiken cookies om je ervaring te verbeteren. Door verder op deze website te surfen, ga je akkoord met ons gebruik van cookies.
            </p>
            <Button variant="cookie-link" as={Link} to="/legal/cookies">Bekijk onze cookie policy</Button>
            <div className="button-container horizontal">
                <Button variant="outlined" onClick={handleAccept}>Accept</Button>
                <Button variant="outlined" onClick={handleDecline}>Decline</Button>
            </div>
        </div>
    );
};

export default CookieBanner;
